import IframePage from './iframePage';
export default IframePage;
